const APPOINTMENT_GUIDES_TITLE = 'Appointment Guides'

/** Metadata only. Each guide's step content lives with the lazy-loaded guides feature, not here. */
interface Guide {
  id: string
  label: string
}

// Each guide is one entry here. The switcher and the header title are built from this list.
const GUIDES: Guide[] = [{ id: 'appointment-flow', label: 'Appointment Flow Guide' }]

const getGuide = (id?: string) => GUIDES.find((guide) => guide.id === id)

export { APPOINTMENT_GUIDES_TITLE, GUIDES, getGuide }
export type { Guide }
